import axiosPackage from "axios";

const getBaseUrl = () =>
  `${window.__ENV__?.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/`;

const axios = axiosPackage.create({
  withCredentials: true,
});

axios.interceptors.request.use(
  async (config) => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Accept-Case-Type": "camel",
      "x-powered-by": "afes",
    };
    config.headers = { ...headers, ...(config?.headers || {}) };
    config.baseURL = getBaseUrl();
    return config;
  },
  (error) =>
    // console.log("AXIOS Request Error");
    Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      axiosPackage.isCancel(error)
        ? "Response was cancelled"
        : (error.response && error.response.data) || "Something went wrong",
    ),
);

export { getBaseUrl };
export default axios;
